export const NOTIFICATIONS_FILTER_OPTIONS = [
    {
        value: true,
        label: "Read"
    },
    {
        value: false,
        label: "Unread"
    }
];

export enum NOTIFICATION_CARD_TYPES {
    CTA = "cta",
    INFO = "info"
}
